/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ObjectID from './ObjectID';

/**
* The DealerContact model module.
* @module model/DealerContact
* @version 4.0.0
*/
export default class DealerContact {
    /**
    * Constructs a new <code>DealerContact</code>.
    * @alias module:model/DealerContact
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>DealerContact</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DealerContact} obj Optional instance to populate.
    * @return {module:model/DealerContact} The populated <code>DealerContact</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DealerContact();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ObjectID.constructFromObject(data['id']);
            }
            if (data.hasOwnProperty('dealerId')) {
                obj['dealerId'] = ObjectID.constructFromObject(data['dealerId']);
            }
            if (data.hasOwnProperty('contactId')) {
                obj['contactId'] = ObjectID.constructFromObject(data['contactId']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/ObjectID} id
    */
    id = undefined;
    /**
    * @member {module:model/ObjectID} dealerId
    */
    dealerId = undefined;
    /**
    * @member {module:model/ObjectID} contactId
    */
    contactId = undefined;




}
